import React from "react";
import { Link } from "react-router-dom";
import { Container, Reveal, useCollection } from "@/components/common";
import PageHero from "@/components/PageHero";
import { getContent } from "@/lib/api";
import { ArrowRight, Warning } from "@phosphor-icons/react";

export default function ClinicalExpertise() {
  const { data } = useCollection(() => getContent("clinical_expertise"), []);
  return (
    <div data-testid="clinical-expertise-page">
      <PageHero label="Clinical Expertise" title="Specialist Cancer Care"
        intro="Patient-friendly information on the cancers Dr. Sirohi specialises in — grounded in evidence and international guidelines."
        image="https://images.pexels.com/photos/14528981/pexels-photo-14528981.jpeg" />

      <section className="bg-white py-16">
        <Container>
          <div className="mb-10 flex items-start gap-3 rounded-md border border-gold/40 bg-gold/5 p-4 text-sm text-navy/80">
            <Warning size={20} className="mt-0.5 shrink-0 text-gold-dark" />
            <p>This educational content is for general information only and does not replace an individual medical consultation. Please consult a qualified specialist for advice about your specific situation.</p>
          </div>
          <div className="grid gap-px overflow-hidden rounded-lg border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-3">
            {data.map((c, i) => (
              <Reveal key={c.id} delay={(i % 3) * 0.05}>
                <Link to={`/clinical-expertise/${c.slug}`} data-testid={`clinical-card-${c.slug}`} className="group flex h-full flex-col bg-white p-8 transition-colors hover:bg-navy">
                  <h3 className="font-serif text-2xl text-navy transition-colors group-hover:text-white">{c.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-softgrey-600 transition-colors group-hover:text-slate-300">{c.summary}</p>
                  <span className="mt-5 flex items-center gap-1.5 text-xs font-semibold text-gold-dark group-hover:text-gold">Read more <ArrowRight size={13} /></span>
                </Link>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
